import { render, staticRenderFns } from "./background.vue?vue&type=template&id=1cf7d51e"
import script from "./background.vue?vue&type=script&lang=js"
export * from "./background.vue?vue&type=script&lang=js"
import style0 from "./background.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports